// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HTML: <div class="loader"></div> */
.loader {
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 8px solid #0000;
    border-right-color: #ffa50097;
    position: relative;
    animation: l24 1s infinite linear;
  }
  .loader:before,
  .loader:after {
    content: "";
    position: absolute;
    inset: -8px;
    border-radius: 50%;
    border: inherit;
    animation: inherit;
    animation-duration: 2s;
  }
  .loader:after {
    animation-duration: 4s;
  }
  @keyframes l24 {
    100% {transform: rotate(1turn)}
  }`, "",{"version":3,"sources":["webpack://./src/components/loading/KeduLoading.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;IAEE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,MAAM,wBAAwB;EAChC","sourcesContent":["/* HTML: <div class=\"loader\"></div> */\n.loader {\n    width: 50px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    border: 8px solid #0000;\n    border-right-color: #ffa50097;\n    position: relative;\n    animation: l24 1s infinite linear;\n  }\n  .loader:before,\n  .loader:after {\n    content: \"\";\n    position: absolute;\n    inset: -8px;\n    border-radius: 50%;\n    border: inherit;\n    animation: inherit;\n    animation-duration: 2s;\n  }\n  .loader:after {\n    animation-duration: 4s;\n  }\n  @keyframes l24 {\n    100% {transform: rotate(1turn)}\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
